import { IStyle } from '@fluentui/react';

export interface IPieChartStyles {
  root: IStyle;
}

export interface IPieChartClassNames {
  root: string;
}

export const pieChartStylesDefault: Partial<IPieChartStyles> = {
  root: {
    height: '100%',
  },
};
